import React, { useContext, useMemo, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { Box, Button, Dialog, DialogContent, Paper, TextField, Tooltip, Typography, Drawer } from '@mui/material'
import { AiOutlineColumnHeight } from "react-icons/ai";
import Bid from '../components/Quote/Bid';
import Ask from '../components/Quote/Ask';
import { Virtuoso } from 'react-virtuoso';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import Low from '../../components/global/BidAsk/Low';
import High from '../../components/global/BidAsk/High';
import SpreadValue from '../../components/global/BidAsk/SpreadValue';
import PercentageChange from '../../components/global/BidAsk/PercentageChange';
import DailyChange from '../../components/global/BidAsk/DailyChange';
import AmountInput from '../components/Quote/AmountInput';
import { MdAdsClick } from "react-icons/md";
import MenuComponent from '../../components/menu/MenuComponent';
import { setGlobalSymbolID, setGlobalSymbolsData, setModifyPositionOpen, setTradeModalOpen } from '../../store/Slices/globalSymbolSlice';
import TradeModal from '../../components/modal/trading/TradingModal';
import { handleCloseCreateOrder } from '../../store/Slices/panelSlice';
import { OneClickTrading as OneClickTradingAPI } from '../../api/request/dashboard/dashboard';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from 'react-i18next';
import OneClickModal from '../../components/modal/OneClickTrading';
export const amountMap = new Map(JSON?.parse(localStorage?.getItem('amountMap')));

export const updateAmountMap = (symbolId, data) => {
    amountMap.set(symbolId, data)
    localStorage.setItem('amountMap', JSON.stringify([...amountMap]))
}

const Quotes = () => {
    const { darkMode } = useContext(ThemeContext);
    const { symbols } = useSelector(state => state.watchlist);
    const { userDetail } = useSelector(state => state.user);
    const { accountId } = useSelector(state => state.accountSummary)
    const id = userDetail?.id;
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isTradePanelOpen, setIsTradePanelOpen] = useState(false);
    const { orderPanelOpen } = useSelector(state => state.globalSymbol);
    const symbolParameterData = useSelector((state) => state.symbol.allSymbolParams, shallowEqual);
    const [hiddenSymbols, setHiddenSymbols] = useState(() => new Set(JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || []));
    const { isUserSigned, isOneclick } = useSelector((state) => state.watchlist)
    const [showOneClickModal, setShowOneClickModal] = useState(false);
    const [oneClickMode, setOneClickMode] = useState(false);

    const handleToggleOneClick = () => {
        if (isUserSigned) {
            setOneClickMode(prev => !prev);
        } else {
            setShowOneClickModal(true);
        }
    };


    const filteredSymbols = useMemo(() => {
        return Object.values(symbols)
            .filter(symbol => symbol.isVisible && symbol.isUsed && !hiddenSymbols.has(symbol.id))
            .filter(symbol => symbol.name.toLowerCase().includes(searchQuery.toLowerCase()));
    }, [symbols, hiddenSymbols, searchQuery]);


    const handleTrade = async (side, symbolId) => {
        console.log(amountMap.get(symbolId))
        try {
            if (!symbolId) {
                console.error("Symbol ID is missing.");
                return;
            }
            const amount = amountMap.get(symbolId) || symbolParameterData?.[symbolId]?.minimumAmountPerDeal
            const payload = { accountId: accountId, side, amount, symbolId, comment: "One-click trading" };
            const response = await OneClickTradingAPI(payload);
            if (response?.data?.id) {
                const tradeId = response.data.id;
                const symbolName = symbols?.[symbolId]?.name;
                const tradeSide = side === 1 ? "BUY" : "SELL";
                toast.success(`Trade Opened: ID #${tradeId}, ${symbolName}, ${tradeSide}, Amount: ${amount}`);
            }
        } catch (err) {
            toast.error(err?.response?.data?.message)
        }
    }

    const handleQuoteClick = (symbol) => {
        setSelectedRow(symbol);
        setMobileMenuOpen(true);
    };

    const handleCloseDrawer = () => {
        setMobileMenuOpen(false);
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 300);
    };
    const handleOpenOneTradeModal = () => {
        console.log("Open trade modal for:", selectedRow);
        dispatch(setTradeModalOpen(true))
        dispatch(setModifyPositionOpen(false))
        if (selectedRow) {
            dispatch(setGlobalSymbolID(selectedRow?.id))
            dispatch(setGlobalSymbolsData(selectedRow))
        }
        setIsTradePanelOpen(true);
    };
    const handleHideSymbol = (symbolId) => {
        const updatedHiddenSymbols = new Set(hiddenSymbols);
        if (symbolId !== null) {
            updatedHiddenSymbols.add(Number(symbolId));
        }

        setHiddenSymbols(updatedHiddenSymbols);
        localStorage.setItem(
            `hiddenSymbols_${id}`,
            JSON.stringify(Array.from(updatedHiddenSymbols).filter(Boolean))
        );
    };
    const handleChartClick = () => {
        if (selectedRow) {
            dispatch(setGlobalSymbolsData(selectedRow))
            dispatch(setGlobalSymbolID(selectedRow?.id))
            navigate("/chart");
            console.log(selectedRow);

        }
    };
    const quoteItemDefault = (symbol) => (
        <Box sx={{ p: 1, display: "flex", justifyContent: "space-between" }} onClick={() => handleQuoteClick(symbol)}>
            <Box sx={{ backgroundColor: darkMode ? "#151924" : 'var(--white)' }}>
                <Typography fontSize={12} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><DailyChange symbolId={symbol?.id} /> | <PercentageChange symbolId={symbol?.id} /></Typography>
                <Typography variant="body1" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)', margin: 0 }}>{symbol?.name}</Typography>
                <Box sx={{ display: 'flex', alignItems: "center" }}>
                    <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>{symbol?.tradingTimes?.expiryDate} </Typography>
                    <AiOutlineColumnHeight fontSize={13} style={{ margin: "0 0 0 3px", color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} />
                    <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)', fontWeight: 600 }}><SpreadValue symbolId={symbol?.id} /></Typography>
                </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                <Box>
                    <Bid symbolId={symbol?.id} />
                    <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>L:<Low symbolId={symbol?.id} /></small></Typography>
                </Box>
                <Box sx={{ marginLeft: 2 }}>
                    <Ask symbolId={symbol?.id} />
                    <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>H: <High symbolId={symbol?.id} /></small></Typography>
                </Box>
            </Box>
        </Box>
    );

    const quoteItemOneClick = (symbol) => (
        <Box sx={{ p: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Ask symbolId={symbol?.id} />
                    <Button variant='outlined' size='small' fullWidth sx={{ px: 3 }} color='error' onClick={e => handleTrade(-1, symbol?.id)}>{t('sell')}</Button>
                    <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>H: <High symbolId={symbol?.id} /></small></Typography>
                </Box>
            </Box>
            <Box sx={{ backgroundColor: darkMode ? "#151924" : 'var(--white)', textAlign: "center", display: "flex", flexDirection: "column", alignItems: 'center' }}>
                <Typography variant="body1" fontWeight="bold" sx={{ color: darkMode ? "var(--white)" : 'var(--black)', margin: 0 }}>{symbol?.name}</Typography>
                <AmountInput symbolId={symbol?.id} />
                <Box sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                    {/* <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}>08:27:20 </Typography> */}
                    <Typography fontSize={12} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><DailyChange symbolId={symbol?.id} /> | <PercentageChange symbolId={symbol?.id} /></Typography>
                    <AiOutlineColumnHeight fontSize={13} style={{ margin: "0 0 0 3px", color: darkMode ? "var(--lightText)" : 'var(--darkText)' }} />
                    <Typography fontSize={13} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)', fontWeight: 600 }}><SpreadValue symbolId={symbol?.id} /></Typography>
                </Box>
            </Box>
            <Box>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Bid symbolId={symbol?.id} />
                    <Button variant='outlined' size='small' fullWidth sx={{ px: 3 }} color='success' onClick={e => handleTrade(1, symbol?.id)}>{t('buy')}</Button>
                    <Typography fontSize={14} textAlign={'end'} sx={{ color: darkMode ? "var(--lightText)" : 'var(--darkText)' }}><small>L:<Low symbolId={symbol?.id} /></small></Typography>
                </Box>
            </Box>
        </Box>
    );
    const handleCloseCreateOrderPanel = () => {
        dispatch(handleCloseCreateOrder());
        dispatch(setTradeModalOpen(false))
        setIsTradePanelOpen(false);
    };
    const symbolIds = Object.keys(symbols).map(Number);
    const handleHideAllSymbols = () => {
        const allHidden = new Set(symbolIds);
        setHiddenSymbols(allHidden);
        localStorage.setItem(`hiddenSymbols_${id}`, JSON.stringify(Array.from(allHidden)));
    };
    const handleShowAllSymbols = () => {
        setHiddenSymbols(new Set());
        localStorage.setItem(`hiddenSymbols_${id}`, JSON.stringify([]));
    };

    return (
        <>

            <Box sx={{ height: '100vh', overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ position: 'sticky', top: 0, zIndex: 10, backgroundColor: darkMode ? "#151924" : "#fff", }}>
                    <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 0, width: "100%", backgroundColor: darkMode ? "#202933" : "#f1f1f1" }}>
                        <TextField size="small" variant="outlined" placeholder={t('mobSearch')} value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1, minWidth: 0 }} />
                        <Tooltip title={oneClickMode ? t("defaultView") : t("oneTrading")} arrow><Button onClick={handleToggleOneClick} sx={{ borderRadius: 0, bgcolor: oneClickMode ? 'primary.main' : '#202933', color: oneClickMode ? '#fff' : '#fff', '&:hover': { bgcolor: oneClickMode ? 'primary.dark' : 'rgba(0,0,0,0.04)', }, }}><MdAdsClick style={{ fontSize: 23 }} /> </Button></Tooltip>
                    </Paper>
                </Box>
                {filteredSymbols.length === 0 ? (
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Button onClick={handleShowAllSymbols} variant="outlined" size="small" startIcon={<AddIcon />} sx={{ fontWeight: 500, fontSize: 14, px: 2, textTransform: 'none' }}>{t('Pleaseaddsymbols')}</Button>
                    </Box>) : (
                    <Box sx={{ flexGrow: 1 }}>
                        <Virtuoso key={mobileMenuOpen ? 'drawer-open' : 'drawer-closed'} totalCount={filteredSymbols.length} style={{ height: 'calc(100vh - 64px)' }} itemContent={(index) => {
                            const symbol = filteredSymbols[index];
                            return isUserSigned && oneClickMode ? quoteItemOneClick(symbol) : quoteItemDefault(symbol);
                        }}
                        />
                    </Box>

                )}

            </Box>
            <Drawer anchor="bottom" open={mobileMenuOpen} onClose={handleCloseDrawer}>
                <MenuComponent onOpenTradeModal={handleOpenOneTradeModal} closeMenu={handleCloseDrawer} onChartClick={handleChartClick} darkMode={darkMode} onHideSymbol={handleHideSymbol} isTradePanelOpen={isTradePanelOpen} selectedRow={selectedRow} showNewDashboardOption={false} onHideAllSymbols={handleHideAllSymbols} onShowAllSymbols={handleShowAllSymbols} />
            </Drawer>
            <Dialog open={orderPanelOpen} onClose={handleCloseCreateOrderPanel} maxWidth="lg" fullWidth>
                {/* <DialogTitle>Trade Panel</DialogTitle> */}
                <DialogContent sx={{ p: 0 }}>
                    <TradeModal open={orderPanelOpen} onClose={handleCloseCreateOrderPanel} showCloseButton={true} />
                </DialogContent>
            </Dialog>
            {!isUserSigned && (<OneClickModal isOpen={showOneClickModal} onClose={() => setShowOneClickModal(false)} onAccept={() => { setShowOneClickModal(false) }} />)}
        </>
    );
};

export default Quotes;
